import { Autocomplete, TextField } from "@mui/material";
import { Component } from "react";
import { httpGet, httpPost } from "../util/http";

export default class UnidadeSelect extends Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            loading: false,
        }
    }

    componentDidMount() {
        this.setState({ loading: true });
        httpGet('/unidades/list/basic',
            unidades => {
                //console.log(unidades)
                if (this.props.all) {
                    unidades.unshift({ nome: 'Todos as unidades' });
                    if (this.props.onChange)
                        this.props.onChange(unidades[0]);
                }
                this.setState({
                    items: unidades,
                    loading: false
                });
            },

            error => {
                console.log(error);
                this.setState({ loading: false });
            },

            true //salva no cache
        );
    }

    render() {
        return (
            <Autocomplete {...this.props.props}
                noOptionsText="Nenhuma unidade"
                loadingText="Carregando..."
                openText="Abrir lista"
                loading={this.state.loading}
                value={this.props.value} options={this.state.items}
                size="small"
                disabled={this.props.disabled}
                sx={{
                    ...this.props.sx,
                    // '& fieldset': { borderRadius: 10 }, borderRadius: 10
                }}
                getOptionLabel={option => option.nome}
                getOptionKey={option => option.uuid}
                onChange={(e, value) => this.props.onChange ? this.props.onChange(value) : {}}
                isOptionEqualToValue={(option, value) => { return option.uuid === value.uuid }}
                renderInput={(params) => <TextField
                    {...params}
                    error={this.props.error === true}
                    helperText={this.props.error === true ? "Informe uma unidade" : null}
                    label={'Unidade' + (this.props.required ? '*' : '')} />}
            />
        );
    }
}